import { HTMLAttributes } from "react";
import { cn } from "../lib/utils";
import { HumoMark, HumoWordmark } from "./HumoMark";

interface BrandLogoMarkProps extends HTMLAttributes<HTMLSpanElement> {
  size?: number;
}

export const BrandLogoMark = ({ className, size = 32, ...props }: BrandLogoMarkProps) => (
  <span
    className={cn("inline-flex shrink-0 items-center justify-center", className)}
    style={{ width: size, height: size }}
    {...props}
  >
    <HumoMark className="h-full w-full" />
  </span>
);

interface BrandLogoProps extends HTMLAttributes<HTMLDivElement> {
  showWordmark?: boolean;
  markSize?: number;
  wordmarkClassName?: string;
}

export const BrandLogo = ({
  className,
  showWordmark = false,
  markSize = 32,
  wordmarkClassName,
  ...props
}: BrandLogoProps) => (
  <div className={cn("inline-flex items-center gap-2.5", className)} {...props}>
    <BrandLogoMark size={markSize} />
    {showWordmark && (
      <HumoWordmark className={cn("h-[1.15em] w-auto text-lg text-inherit", wordmarkClassName)} />
    )}
  </div>
);
